/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/10/25
 */
import fetch from 'isomorphic-fetch';
import urlUtil from 'url';

export const csrf = () =>
  fetch('/getcsrf', {
    credentials: 'include'
  }).then(res => res.headers.get('X-CSRF-TOKEN'));

export const post = (url, json) =>
  csrf().then(token => 
    fetch(url, {
      method: 'POST',
      headers: {
        'X-CSRF-TOKEN': token,
        'Content-Type': 'application/json'
      },
      credentials: 'include', //TODO CORS accept set-cookie
      body: JSON.stringify(json)
    }).then(res => res.json())
  );


export const get = (pathname, query = {}) =>
  fetch(urlUtil.format({
    pathname, query
  }), {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    },
    credentials: 'include'
  }).then(res => res.json());



// WEBPACK FOOTER //
// ./src/utils/fetch.js